var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowsToolbarProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2864_9185)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43239 2.00473C4.32984 3.10732 3.42773 4.01782 3.42773 4.02804C3.42773 4.03827 3.61149 4.23054 3.83607 4.45529L4.24441 4.86394L5.2633 3.84518L6.28219 2.82642V8.70898V14.5915H6.87374H7.46529V7.29577C7.46529 3.2831 7.45895 0 7.45117 0C7.44341 0 6.53496 0.902122 5.43239 2.00473ZM9.32445 8.70423C9.32445 12.7169 9.33078 16 9.33849 16C9.34623 16 10.2589 15.0937 11.3666 13.986L13.3807 11.972L12.963 11.554L12.5453 11.1361L11.5264 12.1548L10.5075 13.1736V7.29102V1.40845H9.916H9.32445V8.70423Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2864_9185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.427734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowsToolbarProjects);
export default __webpack_public_path__ + "static/media/icon--arrows-toolbar-projects.c5bbea149b4f9ff8eaf5cc71875b72a5.svg";
export { ForwardRef as ReactComponent };